/*
 * form-loader.js
 * Shows a loading spinner in the consultation form card until the embedded
 * form (Form Builder app, rendered as <shopify-forms-embed>) has been injected
 * and hydrated.
 *
 * The app creates <shopify-forms-embed> client-side — it is NOT in the server
 * HTML — so we can't anchor a loader to it on first paint. Instead the theme
 * section renders a server-side placeholder `[data-form-loading]` inside the
 * `.form-banner`; this script hides that placeholder the moment the form shows
 * up inside the same card (or after a timeout safety net).
 *
 * Keyed off stable hooks only (the placeholder element and the
 * <shopify-forms-embed> tag) — never the app's hashed inner class names.
 */
(function () {
  'use strict';

  var MAX_WAIT = 20000; // safety net so the spinner can never spin forever

  function formReady(scope) {
    var embed = scope.querySelector('shopify-forms-embed');
    if (!embed) return false;
    var shadow = embed.shadowRoot;
    if (shadow && shadow.querySelector('form, input, button, [role]')) return true;
    // Fallback if a version renders into the light DOM.
    return !!embed.querySelector('form, input, button');
  }

  function track(loader) {
    if (loader.__htTracked) return;
    loader.__htTracked = true;
    var scope = loader.closest('.form-banner') || loader.parentElement || document;
    var start = Date.now();

    (function check() {
      if (formReady(scope) || Date.now() - start > MAX_WAIT) {
        loader.classList.add('is-hidden');
        return;
      }
      setTimeout(check, 150);
    })();
  }

  function scan() {
    var loaders = document.querySelectorAll('[data-form-loading]:not(.is-hidden)');
    Array.prototype.forEach.call(loaders, track);
  }

  function boot() {
    scan();
    // The placeholder is in the server HTML, but the form arrives later; keep
    // re-scanning for a short window. track() is idempotent.
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      scan();
      if (tries > 140) clearInterval(poll); // ~21s
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
